import {ThemeLightGreen} from '@hm/fundamental'

export enum StaticPartTypeEnum {
  MixingChamber = 'MixingChamber',
  HotGasGenerator = 'HotGasGenerator',
  Cyclone = 'Cyclone',
  Calciner = 'Calciner',
  RiserDuct = 'RiserDuct',
  InletChamber = 'InletChamber',
  KilnHood = 'KilnHood',
  BurnerPipe = 'BurnerPipe',
  TertiaryAirDuct = 'TertiaryAirDuct',
  SatelliteCooler = 'SatelliteCooler',
  GrateCooler = 'GrateCooler'
}

export enum StaticPartComponentTypeEnum {
  CycloneGasDuct = 'CycloneGasDuct',
  CycloneRoof = 'CycloneRoof',
  CycloneSideWall = 'CycloneSideWall',
  CycloneCone = 'CycloneCone',
  CalcinerHotPart = 'CalcinerHotPart',
  CalcinerColdPart = 'CalcinerColdPart',
  CalcinerGooseNeck = 'CalcinerGooseNeck',
  RiserDuctDuct = 'RiserDuctDuct',
  RiserDuctBullnose = 'RiserDuctBullnose',
  InletChamberDuct = 'InletChamberDuct',
  InletChamberSideWalls = 'InletChamberSideWalls',
  InletChamberRoof = 'InletChamberRoof',
  InletChamberBypass = 'InletChamberBypass',
  InletChamberInletChute = 'InletChamberInletChute',
  KilnHoodUpperPart = 'KilnHoodUpperPart',
  KilnHoodLowerPart = 'KilnHoodLowerPart',
  BurnerPipeLance = 'BurnerPipeLance',
  BurnerPipeTip = 'BurnerPipeTip',
  TertiaryAirDuctDuct = 'TertiaryAirDuctDuct',
  TertiaryAirDuctDumper = 'TertiaryAirDuctDumper',
  TertiaryAirDuctElbow = 'TertiaryAirDuctElbow',
  SatelliteCoolerElbow = 'SatelliteCoolerElbow',
  SatelliteCoolerTube = 'SatelliteCoolerTube',
  GrateCoolerChute = 'GrateCoolerChute',
  GrateCoolerHorseShoe = 'GrateCoolerHorseShoe',
  GrateCoolerBullnose = 'GrateCoolerBullnose',
  GrateCoolerRoofSeparator = 'GrateCoolerRoofSeparator',
  GrateCoolerWallsHotSection = 'GrateCoolerWallsHotSection',
  GrateCoolerBenchHotSection = 'GrateCoolerBenchHotSection',
  GrateCoolerRoofHotSection = 'GrateCoolerRoofHotSection',
  GrateCoolerWallsColdSection = 'GrateCoolerWallsColdSection',
  GrateCoolerBenchColdSection = 'GrateCoolerBenchColdSection',
  GrateCoolerRoofColdSection = 'GrateCoolerRoofColdSection'
}

export enum StaticPartEditModesEnum {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export enum StaticPartInteractionModesEnum {
  MOVE = 'MOVE',
  SELECT = 'SELECT'
}

export enum StaticPartLayerTypes {
  TOP_LAYER = 'WorkLayer',
  '2ND_LAYER' = 'Layer1',
  '3ND_LAYER' = 'Layer2',
  BOTTOM_LAYER = 'ComplementsLayer'
}

const withAlpha = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const StaticPartsColors = [
  ThemeLightGreen.accent_1,
  ThemeLightGreen.accent_2,
  ThemeLightGreen.accent_3,
  ThemeLightGreen.accent_4,
  ThemeLightGreen.accent_5,
  ThemeLightGreen.info,
  ThemeLightGreen.accent_2_faded_40,
  ThemeLightGreen.accent_3_faded_40,
  ThemeLightGreen.accent_4_faded_40,
  ThemeLightGreen.accent_5_toggled
]

export const StaticPartsColorsFaded = StaticPartsColors.map((color) => withAlpha(color, 0.25))
